<script>
  import HighCharts from 'highcharts'
  // import {DarkTheme} from '../../../_default/utils/HighchartsTheme'
  // Apply the theme
  // HighCharts.setOptions(DarkTheme)
  HighCharts.setOptions({
    lang: {
      loading: 'Aguarde...',
      months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      exportButtonTitle: 'Exportar',
      printButtonTitle: 'Imprimir',
      rangeSelectorFrom: 'De',
      rangeSelectorTo: 'Até',
      rangeSelectorZoom: 'Periodo',
      downloadPNG: 'Download imagem PNG',
      downloadJPEG: 'Download imagem JPEG',
      downloadPDF: 'Download documento PDF',
      downloadSVG: 'Download imagem SVG'
      // resetZoom: "Reset",
      // resetZoomTitle: "Reset,
      // thousandsSep: ".",
      // decimalPoint: ','
    }
  })
  export default {
    name: 'graph-media-fipe',
    props: ['data'],
    data () {
      let _data = []
      this.data.forEach(v => {
        _data.push({
          'name': v.comitente,
          'y': Number(v.percentualFipe)
        })
      })
      return {
        options: {

          chart: {
            type: 'column'
          },
          title: {
            text: null
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            title: {
              text: 'Porcentagem média'
            }

          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y:.0f}%'
              }
            }
          },

          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> da FIPE<br/>'
          },

          'series': [
            {
              'name': 'Média X Fipe',
              'colorByPoint': true,
              'data': _data
            }
          ]

        }
      }
    },
    computed: {},
    mounted () {
      this.$el.querySelectorAll('text').forEach((v) => {
        if (v.innerHTML === 'Highcharts.com') {
          v.parentNode.removeChild(v)
        }
      })
      console.log(this.options)
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="bg-black dker">
    <highcharts :options="options"></highcharts>
  </div>
</template>



// WEBPACK FOOTER //
// MediaFipe.vue?e73de5fe